module.exports = __webpack_public_path__ + "static/media/Sentient_Combos.8e3b7958.gif";